import React from "react";
import type { DynamicLayerProps } from "./types";
import PlayNowLayer from "./PlayNowLayer";
import RoyaleLayer from "./RoyaleLayer";
import RoyaleReward from "./RoyaleReward";

// The layer over a changing room's game: everything Play Now and the Royale show
// on top of the board (the next round's reveal, who is out, the set podium, the
// final and its winner). RemoteGame mounts it for those rooms only.
export default function DynamicLayer(props: DynamicLayerProps) {
  if (props.kind !== "royale") return <PlayNowLayer {...props} />;
  // The winner's reward (wins counter, the box to open) rides in the layer's slot.
  const winner = (props.royaleResult && props.royaleResult.winner) || (props.result && props.result.winner) || null;
  const won = !!winner && props.seatIds.indexOf(winner) !== -1;
  return <RoyaleLayer {...props} reward={won ? <RoyaleReward saved={props.resultSaved || 0} /> : undefined} />;
}
